// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IAccountNumberDto
 */
export interface IAccountNumberDto {
    /**
     * 
     * @type {string}
     * @memberof IAccountNumberDto
     */
    account_number?: string;
    /**
     * 
     * @type {string}
     * @memberof IAccountNumberDto
     */
    routing_transit_number?: string;
    /**
     * 
     * @type {number}
     * @memberof IAccountNumberDto
     */
    employee_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IAccountNumberDto
     */
    available_balance?: number;
    /**
     * 
     * @type {string}
     * @memberof IAccountNumberDto
     */
    account_status?: IAccountNumberDtoAccountStatusEnum;
}

/**
* @export
* @enum {string}
*/
export enum IAccountNumberDtoAccountStatusEnum {
    OPEN = 'OPEN',
    CLOSED = 'CLOSED',
    PENDING_CLOSED = 'PENDING_CLOSED',
    FROZEN = 'FROZEN',
    PENDING = 'PENDING'
}


/**
 * Check if a given object implements the IAccountNumberDto interface.
 */
export function instanceOfIAccountNumberDto(value: object): value is IAccountNumberDto {
    return true;
}

export function IAccountNumberDtoFromJSON(json: any): IAccountNumberDto {
    return IAccountNumberDtoFromJSONTyped(json, false);
}

export function IAccountNumberDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAccountNumberDto {
    if (json == null) {
        return json;
    }
    return {
        
        'account_number': json['account_number'] == null ? undefined : json['account_number'],
        'routing_transit_number': json['routing_transit_number'] == null ? undefined : json['routing_transit_number'],
        'employee_id': json['employee_id'] == null ? undefined : json['employee_id'],
        'available_balance': json['available_balance'] == null ? undefined : json['available_balance'],
        'account_status': json['account_status'] == null ? undefined : json['account_status'],
    };
}

export function IAccountNumberDtoToJSON(json: any): IAccountNumberDto {
    return IAccountNumberDtoToJSONTyped(json, false);
}

export function IAccountNumberDtoToJSONTyped(value?: IAccountNumberDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'account_number': value['account_number'],
        'routing_transit_number': value['routing_transit_number'],
        'employee_id': value['employee_id'],
        'available_balance': value['available_balance'],
        'account_status': value['account_status'],
    };
}

